import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"
const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const appDetailAction = createAsyncThunk(
    'app-detail',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/app-detail/${data}`, )
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const appDetailSlice = createSlice({
    name: 'app-detail',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(appDetailAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(appDetailAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(appDetailAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const appDetailReducer = appDetailSlice.reducer